(() => {
  const HOST = '.rollator-card, .drawer-row, .ff-card';
  const SWATCH = '[data-swatch-preview]';

  const imageIn = (host) => (host ? host.querySelector('img') : null);

  const preload = (host) => {
    if (host.dataset.swatchPreloaded) return;
    host.dataset.swatchPreloaded = 'true';
    host.querySelectorAll(SWATCH).forEach((swatch) => {
      const src = swatch.dataset.swatchImage;
      if (src) new Image().src = src;
    });
  };

  const show = (swatch) => {
    const src = swatch.dataset.swatchImage;
    const image = imageIn(swatch.closest(HOST));
    if (!src || !image) return;

    if (image.dataset.swatchFrom === undefined) {
      image.dataset.swatchFrom = image.getAttribute('src') || '';
      image.dataset.swatchFromSet = image.getAttribute('srcset') || '';
    }

    image.removeAttribute('srcset');
    image.setAttribute('src', src);
  };

  const restore = (swatch) => {
    const image = imageIn(swatch.closest(HOST));
    if (!image || image.dataset.swatchFrom === undefined) return;

    image.setAttribute('src', image.dataset.swatchFrom);
    if (image.dataset.swatchFromSet) {
      image.setAttribute('srcset', image.dataset.swatchFromSet);
    }
  };

  const enter = (event) => {
    const host = event.target.closest ? event.target.closest(HOST) : null;
    if (host) preload(host);

    const swatch = event.target.closest ? event.target.closest(SWATCH) : null;
    if (swatch) show(swatch);
  };

  const leave = (event) => {
    const swatch = event.target.closest ? event.target.closest(SWATCH) : null;
    if (swatch) restore(swatch);
  };

  document.addEventListener('pointerover', enter);
  document.addEventListener('pointerout', leave);
  document.addEventListener('focusin', enter);
  document.addEventListener('focusout', leave);
})();
